<template>
  <mdb-modal
    info
    scrollable
    size="xl"
    :show="modal"
    @close="close">
    <mdb-modal-header>
      <mdb-modal-title class="font-weight-bold d-block">利用規約・個人情報の取扱規定</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
      <p class="text-muted font-weight-bold">スクロールして最後までご確認下さい。</p>
      <mdb-row>
        <mdb-col col="12 mb-3">
          <mdb-icon v-if="readTerms" far icon="check-circle" color="success" class="fa-2x" />
          <mdb-scrollspy-box
            class="p-2">
            <mdb-scrollspy-text
              class="p-4 scrollspy-text"
              @scroll.native="termsScroll"
              ref="terms">
              <UserPolicyContent/>
            </mdb-scrollspy-text>
          </mdb-scrollspy-box>
        </mdb-col>
        <mdb-col col="12">
          <mdb-icon v-if="readPrivacyPolicy" far icon="check-circle" color="success" class="fa-2x"/>
          <mdb-scrollspy-box
            class="p-2">
            <mdb-scrollspy-text
              class="p-4 scrollspy-text"
              @scroll.native="privacyPolicyScroll"
              ref="privacyPolicy">
              <PrivacyPolicyContent/>
            </mdb-scrollspy-text>
          </mdb-scrollspy-box>
        </mdb-col>
      </mdb-row>
    </mdb-modal-body>
  </mdb-modal>
</template>

<script>
import UserPolicyContent from '@/components/molecules/UserPolicyContent'
import PrivacyPolicyContent from '@/components/molecules/PrivacyPolicyContent'

export default {
  name: 'RegulationModal',
  components: {
    UserPolicyContent,
    PrivacyPolicyContent
  },
  props: {
    modal: Boolean,
    agreed: Boolean
  },
  data() {
    return {
      readTerms: false,
      readPrivacyPolicy: false
    }
  },
  methods: {
    close: function() {
      this.$emit('close')
    },
    termsScroll: function () {
      if (this.agreed || !this.$refs.terms) return
      if (this.$refs.terms.$el.scrollHeight - Math.round(this.$refs.terms.$el.scrollTop) <= 320) {
        this.readTerms = true
        if (this.readTerms && this.readPrivacyPolicy) {
          this.$emit('agreed')
        }
      }
    },
    privacyPolicyScroll: function () {
      if (this.agreed || !this.$refs.privacyPolicy) return
      if (this.$refs.privacyPolicy.$el.scrollHeight - Math.round(this.$refs.privacyPolicy.$el.scrollTop) <= 320) {
        this.readPrivacyPolicy = true
        if (this.readTerms && this.readPrivacyPolicy) {
          this.$emit('agreed')
        }
      }
    },
  },
  watch: {
    agreed: function(val) {
      if (!val) {
        this.readTerms = false
        this.readPrivacyPolicy = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.scrollspy-text {
  height: 300px;
  font-size: 0.8rem;
}
</style>
